import {isEmpty} from '../utilities/validation';

function handleEvent(event) {
    event.childrenNamed('method_node').forEach(function(method) {
        handleMethod(method);
    });
}

function disableOverlayMask(){
    let ev = new CustomEvent('jre-disable-overlay'); // For the case when a Text Area node appears after
    document.dispatchEvent(ev);                             // an MC-Node has completed (MO.SUDE.3.0.1 P116)
}

function handleTimerMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    //concatenate method name and title to check for substrings "start" and "timer"
    const methodNameAndTitle = method.attr.name.toLowerCase() + method.attr.title.toLowerCase();

    let ev = null;
    if (method.attr.name === 'reset') {
        ev = new CustomEvent('jre-timer-reset', {detail: {target: method.attr.target}});
    } else if (methodNameAndTitle.includes('start') && methodNameAndTitle.includes('timer')) {
        // This condition should handle all the different possibilities for starting timers by titles.
        ev = new CustomEvent('jre-timer-start',  {detail: {target: method.attr.target}});
    } else if (methodNameAndTitle.includes('stop') && methodNameAndTitle.includes('timer')) {
        // This condition should handle all the different possibilities for stopping timers by titles.
        ev = new CustomEvent('jre-timer-stop',  {detail: {target: method.attr.target}});
    } else if (param.attr.value === 'start' && value.attr.value === 'true') {
        ev = new CustomEvent('jre-timer-start',  {detail: {target: method.attr.target}});
    } else if (param.attr.value === 'start' && value.attr.value === 'false') {
        ev = new CustomEvent('jre-timer-stop',  {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handleMCMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    let ev = null;
    if (param.attr.value === 'enabled') {
        ev = new Event('jre-mc-enabled');
    } else if (param.attr.value === 'correct' && value.attr.value.toLowerCase() === 'true') {
        ev = new CustomEvent('jre-mc-correct', {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handleDDMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    if (param && value) {
        let ev = null;
        if (param.attr.value === 'enabled' && value.attr.value === 'true') {
            ev = new Event('jre-dd-enabled');
        }
        ev && document.dispatchEvent(ev);
    }
}

function handleCEMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    if (param && value) {
        let ev = null;
        if (param.attr.value === 'enabled' && value.attr.value.toLowerCase() === 'true') {
            ev = new Event('jre-ce-enabled');
        } else if (param.attr.value === 'start' && value.attr.value === 'false') {
            ev = new CustomEvent('stop_audio', {detail: {target: method.attr.target}});
        }

        ev && document.dispatchEvent(ev);
    }
}

// This handles the case where a method_node starts or stops an audio_node
function handleAudioStartStop(method){
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if (param.attr.value === 'start' && value.attr.value === 'false') {
        ev = new CustomEvent('stop_audio', {detail: {target: method.attr.target}});
    } else if (param.attr.value === 'start' && value.attr.value === 'true') {
        ev = new CustomEvent('start_audio', {detail: {target: method.attr.target}});
    }

    ev && document.dispatchEvent(ev);
}

function handleTEMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if (param.attr.value === 'enabled' && value.attr.value === 'true') {
        ev = new CustomEvent('jre-te-enabled', {detail: {target: method.attr.target}});
    } else if (param.attr.value === 'enabled' && value.attr.value === 'false') {
        ev = new CustomEvent('jre-te-disabled', {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

//handles a method that enables an event
function handleEnableMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    let ev = null;
    if (param.attr.value === 'start' && value.attr.value === 'true') {
        ev = new Event('jre-method-enabled');
    }
    ev && document.dispatchEvent(ev);
}

function handleAnswerMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if (param.attr.value === 'visible' && value.attr.value === 'true') {
        ev = new CustomEvent('jre-answer-visible',  {detail: {target: method.attr.target}});
    } else if (param.attr.value === 'visible' && value.attr.value === 'false') {
        ev = new CustomEvent('jre-answer-invisible',  {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handleMTMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if (param.attr.value === 'visible' && value.attr.value === 'false') {
        ev = new Event('jre-mt-invisible');
    }
    ev && document.dispatchEvent(ev);
}

function handleTipMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if (param.attr.value === 'enabled' && value.attr.value === 'true') {
        ev = new Event('jre-tip-enabled');
    }
    ev && document.dispatchEvent(ev);
}

function handleImageMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if( param && value && method.attr.enabled !== 0 ){
        // To ensure disabled methods don't run conditional above was added
        // Using transformers we disable (e.g. enabled=0) methods from running, for example in Package Design -
        // 3.0.1 pages 607 and 608 the mc_node renders the correct answer if the student gets the answer on both
        // attempts incorrect. However on interaction complete a second img_node is rendered over the mc_node and
        // rather than handling sprite images in the img_node (would also require a transformer fix) we handle it here
        if (param.attr.value === 'visible' && value.attr.value === 'true') {
            ev = new CustomEvent('jre-image-visible',  {detail: {target: method.attr.target}});
        } else if (param.attr.value === 'visible' && value.attr.value === 'false') {
            ev = new CustomEvent('jre-image-invisible',  {detail: {target: method.attr.target}});
        }

        ev && document.dispatchEvent(ev);
    }
}

function handleEnableOrDisableButton(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    if (param && value) {
        let ev = null;
        if (param.attr.value === 'enabled' && value.attr.value === 'true') {
            ev = new CustomEvent('jre-btn-enabled', {detail: {target: method.attr.target}});
        } else if (param.attr.value === 'enabled' && value.attr.value === 'false') {
            ev = new CustomEvent('jre-btn-disabled', {detail: {target: method.attr.target}});
        }

        ev && document.dispatchEvent(ev);
    }
}

function handleVisibilityButton(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    if (param && value) {
        let ev = null;
        if (param.attr.value === 'visible' && value.attr.value === 'true') {
            ev = new CustomEvent('jre-btn-show', {detail: {target: method.attr.target}});

        } else if (param.attr.value === 'visible' && value.attr.value === 'false') {
            ev = new CustomEvent('jre-btn-hide', {detail: {target: method.attr.target}});

        }
        ev && document.dispatchEvent(ev);
    }
}

function handleVisibilityText(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    let ev = null;
    if (param.attr.value === 'visible' && value.attr.value === 'true') {
        ev = new CustomEvent('jre-text-show', {detail: {target: method.attr.target}});

    } else if (param.attr.value === 'visible' && value.attr.value === 'false') {
        ev = new CustomEvent('jre-text-hide', {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handleVisibilityVideo(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    let ev = null;
    if (param.attr.value === 'visible' && value.attr.value === 'true') {
        ev = new CustomEvent('jre-video-show', {detail: {target: method.attr.target}});

    } else if (param.attr.value === 'visible' && value.attr.value === 'false') {
        ev = new CustomEvent('jre-video-hide', {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handleVideoStartStop(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    let ev = null;
    if (param.attr.value === 'start' && value.attr.value === 'false') {
        ev = new CustomEvent('jre-video-stop', {detail: {target: method.attr.target}});
    } else if (param.attr.value === 'start' && value.attr.value === 'true') {
        ev = new CustomEvent('jre-video-start', {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handleAnimationStartStop(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');

    let ev = null;
    if (method.attr.name === 'stopAnimation') {
        ev = new CustomEvent('jre-animation-stop', {detail: {target: method.attr.target}});
    } else if (method.attr.name === 'startAnimation') {
        ev = new CustomEvent('jre-animation-start', {detail: {target: method.attr.target}});
    } else if ((param.attr.value === 'enabled' || param.attr.value === 'start') && value.attr.value === 'false') {
        ev = new CustomEvent('jre-animation-stop', {detail: {target: method.attr.target}});
    } else if ((param.attr.value === 'enabled'  || param.attr.value === 'start') && value.attr.value === 'true') {
        ev = new CustomEvent('jre-animation-start', {detail: {target: method.attr.target}});
    }
    ev && document.dispatchEvent(ev);
}

function handlePrintMethod(method) {
    const param = method.childWithAttribute('name', 'param');
    const value = method.childWithAttribute('name', 'value');
    const event_data = {};

    if (param && value) {
        if (param.attr.value === 'visible'){
            event_data['visible'] = value.attr.value === 'true';
        }
    } else if (method.attr.title.toLowerCase().includes('print')) {
        event_data['visible'] = true;
    }
    if (!isEmpty(event_data)) {
        const print_event = new CustomEvent('jre-print', {detail: event_data});
        document.dispatchEvent(print_event);
    }
}

function handleMethod(method) {
    let ev;

    if (isEmpty(method.attr.target)){
        console.warn('Unhandled method - no target defined:');
        console.warn(method);
    }
    else {
        /* We need to handle case sensitivity issues as the XML file may have target = "mc" or target = "MC".
        NOTE: Always use lower case here. */
        switch (method.attr.target.toLowerCase()) {
            case 'timer': {
                handleTimerMethod(method);
                break;
            }
            case 'mc': {
                handleMCMethod(method);
                break;
            }
            case 'ce': {
                handleCEMethod(method);
                break;
            }
            case 'timeup': {
                ev = new Event('jre-audio-times-up');
                document.dispatchEvent(ev);
                break;
            }
            case 'tutext': {
                ev = new CustomEvent('jre-text-times-up', {detail: method});
                document.dispatchEvent(ev);
                break;
            }
            case 'te': {
                handleTEMethod(method);
                break;
            }
            case 'dd': {
                handleDDMethod(method);
                break;
            }
            case 'answer': {
                handleAnswerMethod(method);
                handleVisibilityText(method);
                break;
            }
            case 'mt': {
                handleMTMethod(method);
                break;
            }
            case 'tip': {
                handleTipMethod(method);
                break;
            }
            case 'avi': {
                handleVisibilityVideo(method);
                break;
            }
            case 'vf': {
                handleVisibilityVideo(method);
                break;
            }
            case 'print':
                handlePrintMethod(method);
                break;
            default: {
                /* Sometimes the method attr target will be the ID of the component */
                const target_type = method.attr.target_type.toLowerCase();
                if (target_type === 'button') {
                    handleCEMethod(method);
                    handleDDMethod(method);
                    handleEnableOrDisableButton(method);
                    handleVisibilityButton(method);
                    handlePrintMethod(method);
                } else if (target_type === 'textentry') {
                    handleTimerMethod(method);
                    handleVisibilityButton(method);
                    handleImageMethod(method);
                    handleTEMethod(method);
                    handleDDMethod(method);
                } else if (target_type === 'event') {
                    handleTEMethod(method);
                    handleTimerMethod(method);
                } else if (target_type === 'method') {
                    handleEnableMethod(method);
                } else if (target_type === 'clickexplore') {
                    handleVisibilityVideo(method);
                    handleCEMethod(method);
                    handleDDMethod(method);
                    handleTEMethod(method);
                    handleTimerMethod(method);
                    handleAudioStartStop(method);
                    handleImageMethod(method);
                    handleVisibilityText(method);
                    handleEnableOrDisableButton(method);
                    handleAnimationStartStop(method);
                    handlePrintMethod(method);
                } else if (target_type === 'multiplechoice') {
                    handleCEMethod(method);
                    handleMCMethod(method);
                    handleTEMethod(method);
                } else if (target_type === 'audio') {
                    ev = new CustomEvent('jre-audio-times-up', {detail: {target: method.attr.target}});
                    document.dispatchEvent(ev);
                } else if (target_type === 'text') {
                    handleVisibilityButton(method);
                    handleVisibilityText(method);
                    ev = new CustomEvent('jre-text-times-up', {detail: method});
                    document.dispatchEvent(ev);
                } else if (target_type === 'image') {
                    handleAnimationStartStop(method);
                    handleImageMethod(method);
                    handleVisibilityButton(method);
                    handleVisibilityText(method);
                } else if (target_type === 'timer') {
                    handleTimerMethod(method);
                } else if (target_type === 'video') {
                    handleVisibilityVideo(method);
                    handleVideoStartStop(method);
                    handleAudioStartStop(method); // Needed for modules where target type is video, but target is video or audio based on AS eval
                    // SEE: MO.GRAV.3.2.0 Page 114 id=266175 method_node Also Page 117
                } else if (target_type === 'anim') {
                    handleAnimationStartStop(method);
                } else {
                    console.warn('Unhandled method:');
                    console.warn(method);
                }
            }
        }
    }
}

export {
    handleEvent,
    disableOverlayMask
};



// WEBPACK FOOTER //
// ./src/js/events/event-handler.js